import _defineProperty from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __rest } from "tslib";
import React from 'react';
import cn from 'classnames';
import styles from './field.module.css';
import { Size } from '../../enums/size';
export function Field(Component) {
  var showLabel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var preventLabelClick = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var handlePreventLabelClick = function handlePreventLabelClick(event) {
    return preventLabelClick && event.preventDefault();
  };
  return function (props) {
    var label = props.label,
      note = props.note,
      _props$errorMessage = props.errorMessage,
      errorMessage = _props$errorMessage === void 0 ? '' : _props$errorMessage,
      valid = props.isValid,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$hideNoteSpace = props.hideNoteSpace,
      hideNoteSpace = _props$hideNoteSpace === void 0 ? false : _props$hideNoteSpace,
      componentProps = __rest(props, ["label", "note", "errorMessage", "isValid", "fullWidth", "hideNoteSpace"]);
    var WrapComponent = showLabel ? 'label' : 'span';
    var isSmall = componentProps.size !== Size.Large;
    var isValid = valid === true;
    var isError = valid === false;
    var renderNote = function renderNote() {
      return React.createElement("span", {
        className: cn(styles.fieldNote, _defineProperty({}, styles.error, isError)),
        "data-test": isError ? 'error' : 'note'
      }, isError ? errorMessage : note);
    };
    var Note = function Note() {
      if (!hideNoteSpace) {
        return renderNote();
      }
      if (errorMessage || note) {
        return renderNote();
      }
      return null;
    };
    return React.createElement(WrapComponent, {
      className: cn(styles.field, _defineProperty({}, styles.fullWidth, fullWidth)),
      onClick: handlePreventLabelClick
    }, showLabel && isSmall && label && React.createElement("span", {
      className: styles.fieldLabel
    }, label), React.createElement(Component, Object.assign({}, props, {
      label: label,
      isValid: isValid,
      isError: isError
    })), React.createElement(Note, null));
  };
}